import { render, staticRenderFns } from "./AppServiceView.vue?vue&type=template&id=444b36a2"
import script from "./AppServiceView.vue?vue&type=script&lang=js"
export * from "./AppServiceView.vue?vue&type=script&lang=js"
import style0 from "./AppServiceView.vue?vue&type=style&index=0&id=444b36a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports